// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".track[data-v-7507bf1a] {\n  --magic-progress-bar-track-background: #2f3131;\n}", ""]);
// Exports
module.exports = exports;
